module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flash-messages"
  }, _vm._l((_vm.flashMessages), function(flashMessage) {
    return _c('flash-messages-item', {
      key: flashMessage.id,
      attrs: {
        "message": flashMessage.message,
        "type": flashMessage.type
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b817fe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FlashMessages/FlashMessagesList.vue
// module id = 1314
// module chunks = 1